const ORGANISATION_TAB = 0;
const PARTNER_TAB = 1;

export { ORGANISATION_TAB, PARTNER_TAB};